import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=bf7c4ed4&scoped=true&"
import script from "./ShippingAddress.vue?vue&type=script&lang=js&"
export * from "./ShippingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=bf7c4ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c4ed4",
  null
  
)

export default component.exports